import SimulationFlow from "./SimulationFlow.mjs";
import Glob from "../../../libs/Glob.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import {Button, ButtonGroup} from "reactstrap";
import ChevronRightIcon from "../../../media/images/ChevronRightIcon.mjs";
import CheckIcon from "../../../media/images/CheckIcon.mjs";
import ListIcon from "../../../media/images/ListIcon.mjs";
import AppTrashIcon from "../../../media/app-images/AppTrashIcon.mjs";
import appLib from "../../../libs/appLib.mjs";

const SimulationFlowEdit = class extends SimulationFlow {
	constructor(props) {
		super(props);
		this.state.editing = Number(Glob.getPageParam("simul"));
	}
	renderDefaultStep(upd) {
		const s = this.state.simul?.status || 0;
		const did = this.flowSteps().map( (d, idx, all) => {
			d.done = s >= d.threshold;
			d.prevDone = idx ? s >= all[idx -1].threshold : true;
			return d;
		});
		const i = <CheckIcon style={{fill:"#090"}}/>
		return(
			<>
				<div
					key={"overview"-upd}
					className={"panel-content limited"}
				>
					<h3>
						<TextLabel value={"Overview"} />
					</h3>
					{ !! this.state.simul.name && <h4>{ this.state.simul.name }</h4> }
					{ !! this.state.simul.description && <p>{ this.state.simul.description }</p> }
					{ !! this.state.peri?.name && <p><TextLabel value={"Perimeter"} />: <strong>{ this.state.peri.name }</strong></p> }
					<table className="table table-striped">
						<tbody>
						{ did.map((d, idx) => (
							<tr
								key={idx}
								style={ d.prevDone ? {cursor: "pointer",fontWeight:"bold"} : undefined}
								onClick={ d.prevDone ? ()=>Glob.setCurrentPageParam('step',d.label) : undefined }
							>
								<td width={"1%"}>
									{ d.done ? i : null }
								</td>
								<td>
									<TextLabel value={ d.info } />
								</td>
							</tr>
						))}
						</tbody>
					</table>
				</div>
				<div className={"panel-footer"}>
					<ButtonGroup
						className={"btn-icon"}
					>
						<Button
							color={"success"}
							onClick={()=>Glob.gotoPage('Simulations')}
						>
							<i>
								<ListIcon />
							</i>
							<b>
								<TextLabel value={"Available simulations"} />
							</b>
						</Button>
					</ButtonGroup>
					<ButtonGroup className={"btn-icon"}>
						<Button
							hidden={ ! this.state.simul.id || ! appLib.enabled() }
							color={"danger"}
							onClick={ ()=>{
								if ( ! window.confirm( Glob.label('ConfirmCannotUndo'))) return;
								appLib.api('simul/remove', { id: this.state.simul.id }).then( () => {
									Glob.gotoPage('Simulations');
								}).catch( err => {
									console.log(err);
								});
							}}
						>
							<i>
								<AppTrashIcon />
							</i>
							<b>
								<TextLabel value={"Delete"} />
							</b>
						</Button>
					</ButtonGroup>
					<ButtonGroup className={"btn-icon"}>
						<Button
							color={"success"}
							onClick={() => { Glob.setCurrentPageParam('step', 'info')}}
						>
							<b>
								<TextLabel value={"Info"} />
							</b>
							<i>
								<ChevronRightIcon />
							</i>
						</Button>
					</ButtonGroup>
				</div>
			</>
		)
	}
}

export default SimulationFlowEdit;
